'use client'

// components
import Nav from '@/components/Nav'
import Footer from '@/components/Footer';

// blocks
import Header from '@/blocks/Header'
import ServerSection from '@/blocks/server/ServerSection'
import StatisticsSection from '@/blocks/server/StatisticsSection'
import BoostRulesSection from '@/blocks/server/BoostRulesSection'
import SearchOrAskSection from '@/blocks/server/SearchOrAskSection'
import ObservrSection from '@/blocks/server/ObservrSection'
import LibraryHeading from '@/blocks/LibraryHeading'
import IconGrid from "@/blocks/IconGrid";
import CodeExample from "@/blocks/CodeExample";
import TwoColumnFeatures from "@/blocks/TwoColumnFeatures";
import Embeddable from "@/blocks/Embeddable";
import DeveloperKit from "@/blocks/DeveloperKit";
import FeatureGrid from "@/blocks/FeatureGrid";
import Pricing from '@/blocks/Pricing';

export default function Home() {
  return (
    <div style={{ maxWidth: 'var(--MaxWidth)', margin: '0 auto' }}>
      <Nav wide/>
      <main>
        <Header/>
        {/* <IconGrid/> */}
        {/* <Callout>Indx connects keywords and finds what traditional search engines miss.</Callout> */}
        <ServerSection/>
        {/* The hero's order: search (what visitors do, what you lift), ask, observe (Observr reads
            the statistics and proposes boosts and synonyms, so it comes after them). */}
        <StatisticsSection/>
        <BoostRulesSection/>
        <SearchOrAskSection/>
        <ObservrSection/>
        <LibraryHeading/>
        <FeatureGrid/>
        <CodeExample/>
        <TwoColumnFeatures>
          <Embeddable/>
          <DeveloperKit/>
        </TwoColumnFeatures>
        <Pricing/>
      </main>
      <Footer/>
    </div>
  );
}

